module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO52Pasivos.574046e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO52Pasivos.mp4
// module id = 778
// module chunks = 1